module.exports = __webpack_public_path__ + "static/media/Ingram.e5592536.png";